import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import './styles/App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Routes>
          {/* Redirect root to home */}
          <Route 
            path="/" 
            element={<Navigate to="/home" replace />} 
          />
          
          {/* Home route - no longer protected */}
          <Route path="/home" element={<HomePage />} />
          
          {/* Catch all route - redirect to home */}
          <Route 
            path="*" 
            element={<Navigate to="/home" replace />} 
          />
        </Routes>
      </main>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Therize.net - All rights reserved</p>
      </footer>
    </div>
  );
}

export default App;
